import React from "react";
import { useTranslation } from "react-i18next";

const PethubApp = () => {
  const { t } = useTranslation();
  return (
    <div className="parent-container-short">
      <div className="coming-soon ">
        <h1>Coming soon . . .</h1>
      </div>
      <div className="pethubapp-main-container">
        <div className="pethubapp-left-container">
          <div className="pethub-app-icon-and-title-text">
            <img src="../img/pethub app icon.png" alt="" />
            <p>{t("pethub app")}</p>
          </div>
          <div className="pethub-app-second-text-container">
            <p>{t("pethub app second text")}</p>
          </div>
          <div className="pethub-app-download-icons">
            <img src="../img/appstore.png" alt="" />
            <img src="../img/playstore.png" alt="" />
          </div>
        </div>

        <div className="pethubapp-right-container">
          <img src="../img/HEROV44.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default PethubApp;
